import type { ListOutput } from '@allocab/allocab-standard-shared-types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ExtranetRidesListInput, ExtranetTripOutput, TripsQueryInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { toPageableRangeInput } from '../mappers';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `GET /v1/trips` — courses du compte sur la période, filtrables par statut
 * (vue aplatie `TripStatusFilter`) et par nom de passager. Le back ne renvoie
 * pas de total : la pagination se fait à l'aveugle.
 */
export const useRides = (input: ExtranetRidesListInput) =>
  useQuery<ListOutput<ExtranetTripOutput>>({
    queryKey: extranetQueryKeys.rides.list(input),
    queryFn: () =>
      getExtranetApi().get<TripsQueryInput, ListOutput<ExtranetTripOutput>>('/v1/trips', {
        ...toPageableRangeInput(input, {
          offset: input.page && input.limit ? (input.page - 1) * input.limit : undefined,
          limit: input.limit,
        }),
        status: input.status?.length ? input.status : undefined,
        passengerFirstName: input.passengerFirstName || undefined,
        passengerLastName: input.passengerLastName || undefined,
      }),
    enabled: Boolean(input.dateRange?.from && input.dateRange?.to),
    placeholderData: keepPreviousData,
  });
